import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/molecules/Header/Header';
import LeftMenu from './components/molecules/LeftMenu/LeftMenu';
import Main from './components/molecules/Main/Main';
import { PageNotFound } from './components/pages/PageNotFound';
import { LaunchJob } from './components/pages/LaunchJob';

function App() {
  return (
    <Router>
      <div className="App">
        <Header/>
        <LeftMenu/>
        <main className="main container" id="main">
          <Routes>
            <Route path='/' element={<Main/>}/>
            <Route path='/launch-job' element={<LaunchJob/>}/>

            <Route path={"*"} element={<PageNotFound/>}/>
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;